var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498",
    transform: "translate(-889 -298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10496",
    "data-name": "Group 10496",
    transform: "translate(123.875 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    className: "cls-1",
    d: "M240.165,35.125h-2.04c-11.55,0-21,11.064-21,24.586s9.45,24.586,21,24.586h48c11.55,0,21-11.064,21-24.586s-9.45-24.586-21-24.586h-2.04",
    transform: "translate(549 263.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    className: "cls-1",
    d: "M238.165,39.125h-2.04c-8.25,0-15,7.9-15,17.561s6.75,17.561,15,17.561h48c8.25,0,15-7.9,15-17.561s-6.75-17.561-15-17.561h-2.04",
    transform: "translate(550.76 267.046)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10496-2",
    "data-name": "Group 10496",
    transform: "translate(794.325 268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    className: "cls-1",
    d: "M241.245,30.125h-4.62c-.9,0-1.5.709-1.5,1.772V43.38c0,1.063.6,1.772,1.5,1.772h30.84c.9,0,1.5-.709,1.5-1.772V31.9c0-1.063-.6-1.772-1.5-1.772h-4.62",
    transform: "translate(-235.125 -5.333)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1749",
    "data-name": "Ellipse 1749",
    className: "cls-2",
    cx: 6.72,
    cy: 6.72,
    r: 6.72,
    transform: "translate(10.08 18.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    className: "cls-1",
    d: "M241.8,26.712A8.963,8.963,0,0,1,248.1,24a8.379,8.379,0,0,1,6.3,2.712",
    transform: "translate(-231.24 -11.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    className: "cls-1",
    d: "M238.9,24.37a15.163,15.163,0,0,1,21.3,0",
    transform: "translate(-233.14 -13.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    className: "cls-1",
    d: "M236.1,22.178a20.937,20.937,0,0,1,29.7,0",
    transform: "translate(-234.18 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10497",
    "data-name": "Group 10497",
    transform: "translate(799.609 323.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7387",
    "data-name": "Path 7387",
    className: "cls-3",
    d: "M4.606,3.125H0",
    transform: "translate(9.213 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    className: "cls-3",
    d: "M4.606,3.125H0",
    transform: "translate(18.426 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    className: "cls-3",
    d: "M4.606,3.125H0",
    transform: "translate(0 -3.125)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3092",
    "data-name": "Rectangle 3092",
    className: "cls-4",
    width: 90,
    height: 90,
    transform: "translate(890 298)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.16e3225d1537185153453f1f98bc9f90.svg";
export { ForwardRef as ReactComponent };